export enum DeeplinkLoggerEventName {
  ClickCtaButton = 'click_cta_button',
  ImpressionQrFloating = 'impression_qr_floating',
  ClickCtaText = 'click_cta_text',
}
